import { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { Link } from "react-router-dom";
import { ventrisConfig } from '../ventris.config';
import { focusFirstInvalidField } from '../accessibility/focus';
import AsyncStatus from '../components/AsyncStatus';

import logo from '../assets/img/logo.jpg';

function JoinTest() {
  const [code, setCode] = useState("");
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidated(true);
      focusFirstInvalidField(form);
      return;
    }

    const normalizedCode = code.trim().toUpperCase();
    setValidated(true);
    setError("");
    setLoading(true);

    try {
      const response = await fetch(ventrisConfig.url + '/api/test/join', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          code: normalizedCode
        })
      });

      const data = await response.json();
      if (!data.success || !data.token || !data.test) {
        setError(data.message || "We couldn't find a test with that code.");
        return;
      }

      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("portal", data.portal || "student");
      sessionStorage.setItem("current_user", JSON.stringify(data.current_user || {}));
      document.location.href = "/student-test/WRA/" + data.test.id;
    } catch (joinError) {
      console.error(joinError);
      setError("An error occurred while starting the test. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid as="main" id="main-content" tabIndex={-1} className="login-wrapper" aria-busy={loading}>
      <AsyncStatus busy={loading} busyMessage="Starting test." completeMessage="Test request completed." />
      <Row className="login-row">
        <Col className="login-card">
          <div className="login-card-inner">
            <div className="login-card-header">
              <img src={logo} alt="Ventris Learning Logo" className="login-logo" />
            </div>
            <div className="login-card-divider" />
            <div className="login-card-body">
              <h1 className="login-title">Start Student Test</h1>
              <p className="login-subtitle">Enter your test code to join directly in student mode.</p>
              <Form className="login-form" noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group className="mb-3 ventris-form-element" controlId="joinTestCode">
                  <div className="login-label-row">
                    <Form.Label className="form-label-text">TEST CODE</Form.Label>
                  </div>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Test Code"
                    value={code}
                    onChange={(event) => setCode(event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))}
                    autoComplete="off"
                    autoFocus
                  />
                  <Form.Control.Feedback type="invalid">Please enter a test code.</Form.Control.Feedback>
                </Form.Group>
                {error !== "" ? <Alert variant="danger" className="login-error">{error}</Alert> : null}
                <div className="login-actions">
                  <Button
                    type="submit"
                    className={`login-btn-primary${code.trim() ? " login-btn-primary-active" : ""}`}
                    disabled={loading || code.trim() === ""}
                  >
                    {loading ? "Starting Test..." : "Start Test"}
                  </Button>
                  <Link className="login-btn-secondary" to="/">
                    Return to Login
                  </Link>
                </div>
              </Form>
            </div>
            <div className="login-card-divider" />
            <div className="login-card-footer">
              <span className="login-help-text">
                Need help? Contact <a className="login-help-link" href="mailto:help@ventrislearning.com">help@ventrislearning.com</a>.
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default JoinTest;
